// Simplified Azure AD SSO Configuration (Implicit Flow)
// Similar to innovationOS implementation

export const azureConfig = {
  clientId: 'a593fa85-2812-452f-9fb6-3a34fee00881',
  tenantId: '9133aec2-7cdd-4b6f-a5cc-65e7eb1384ec',
  redirectUri: window.location.origin,
  scopes: 'openid profile User.Read',
};

export const getAuthUrl = () => {
  const nonce = Math.random().toString(36).substring(2);
  const state = Math.random().toString(36).substring(2);
  
  // Store state and nonce for validation
  sessionStorage.setItem('azure_auth_state', state);
  sessionStorage.setItem('azure_auth_nonce', nonce);
  
  const params = new URLSearchParams({
    client_id: azureConfig.clientId,
    response_type: 'id_token', // Solo ID token (no access token)
    redirect_uri: azureConfig.redirectUri,
    scope: azureConfig.scopes,
    response_mode: 'fragment',
    state: state,
    nonce: nonce,
    prompt: 'select_account',
  });
  
  return `https://login.microsoftonline.com/${azureConfig.tenantId}/oauth2/v2.0/authorize?${params.toString()}`;
};
